import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { cqAPI } from "../../lib/Auth";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Heading,
  Text, Flex,
  useToast
} from "@chakra-ui/react";
import ChangePasswordComponent from "../ChangePassword/ChangePasswordComponent";

const ResetPassword = () => {
  const navigate = useNavigate()
  const toast = useToast();
  const { tokenId } = useParams();

  const VerifyAndRedirect = async ()=> {
    await cqAPI.post('/reset-password', {
      vtoken: tokenId,
      referrerHost : location.host
    }).then(response => {
      if (response.type === 'ok') {
        if (response.data && response.data.msg) {
          toast({
            title: 'Thank you',
            description: response.data.msg,
            status: 'success',
            isClosable: true,
          })
        }
      } else {
        toast({
          title: "Error",
          description: response.msg,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        navigate('/');
      }
    })
  }


  useEffect(()=>{
    VerifyAndRedirect()
  },[])

  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertStatus, setAlertStatus] = useState("error");
  const [alertMessage, setAlertMessage] = useState("");
  const [password, setPassword] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const showAlert = (message, status = "error") => {
    setAlertMessage(message);
    setAlertStatus(status);
    setIsAlertVisible(true);
  }

  const processChange = (response) => {
    const {msg} = response;
    if (response.type === "ok") {
      const successMessage = msg || "Password changed successfully";
      toast({
        title : successMessage,
        status : 'success',
        isClosable: true,
      })
      setSubmitDisabled(true);
      navigate('/');
    } else {
      showAlert(msg || "Password reset failed");
    }
  };

  const changePassword = async (event) => {
    event.preventDefault();
    setIsAlertVisible(false);
    try {
      const response = await cqAPI.post("/change-password", {
        ...(password ? {password} : {}),
        vtoken: tokenId
      });
      processChange(response);
    } catch (error) {
      showAlert(`Error during password reset: ${error.message}`)
    }
  };

  return (
    <Flex minH="100vh" justifyContent="center" alignItems="center" bg="gray.50">
      <Box
        p={8}
        minWidth={{ base: "90%", sm: "400px", md: "500px", lg: "500px" }}
        maxWidth={{ base: "90%", sm: "540px", md: "600px", lg: "800px" }}
        borderWidth={1}
        borderRadius={8}
        boxShadow="lg"
        bg="white"
      >
        {isAlertVisible && (
          <Alert status={alertStatus} mb={4}>
            <AlertIcon />
            <Box flex="1">
              <AlertTitle>
                <Text casing="capitalize">{alertStatus}</Text>
              </AlertTitle>
              <AlertDescription display="block">
                {alertMessage}
              </AlertDescription>
            </Box>
          </Alert>
        )}

        <Box textAlign="center" mb={4}>
          <Heading as="h1" fontSize={{ base: "16px", md: "20px", lg: "24px" }}>
            Change Password
          </Heading>
        </Box>

        <form onSubmit={changePassword}>
          <ChangePasswordComponent
            isVisible
            onPasswordChange={(value) => setPassword(value)}
            onIsInvalidChange={(value) => setSubmitDisabled(value)}
            validationErrors={[]}
          />
          <Button
            width="full"
            mt={4}
            type="submit"
            colorScheme="teal"
            isDisabled={submitDisabled}
          >
            Change password
          </Button>
        </form>
      </Box>
    </Flex>
  );

}

export default ResetPassword;